import { z } from 'zod';
export const LICENSE_EXPIRED_MESSAGE = 'Device license has expired. Renew it on the Cameras page.';
export const SignedLicenseSchema = z.object({
    payload: z.string().min(1).max(12000).regex(/^[A-Za-z0-9_-]+$/),
    signature: z.string().length(86).regex(/^[A-Za-z0-9_-]+$/),
}).strict();
export const LicenseClaimsSchema = z.object({
    version: z.literal(1),
    kind: z.literal('device-license'),
    licenseId: z.string().uuid(),
    deviceId: z.string().uuid(),
    hardwareId: z.string().regex(/^[a-f0-9]{64}$/),
    serverUrl: z.string().url().max(500),
    plan: z.enum(['streaming', 'ai_streaming']),
    issuedAt: z.number().int().nonnegative(),
    expiresAt: z.number().int().positive(),
    expiryBasis: z.literal('Europe/Berlin').optional(),
}).strict().refine(value => value.expiresAt > value.issuedAt, 'License expiry must follow issuance');
//# sourceMappingURL=licenses.js.map